import React, { FC } from "react";
import hydreualys from "../../images/logo/hydreualys-logo.png";
import aquavesc from "../../images/logo/aquavesc-logo.png";

interface LogoProps {
  className?: string;
}

const Logo: FC<LogoProps> = ({}) => {
  return (
    <div className="flex items-center space-x-5">
      <div>
        <a
          href={process.env.REACT_APP_HYDREAULYS_URL}
          target="_blank"
          rel="noreferrer"
        >
          <img className="w-[4rem] " src={hydreualys} alt="LogoImg" />
        </a>
      </div>
      <div>
        <a
          href={process.env.REACT_APP_AQUAVESC_URL}
          target="_blank"
          rel="noreferrer"
        >
          <img className="w-20 " src={aquavesc} alt="LogoImg" />
        </a>
      </div>
    </div>
  );
};

export default Logo;
